import loader from '../../common/loader';
import cookie from '../../common/cookie';
import miloRequest from '../../common/network'; // 微信JSSDK add by weiztang 微信接口开放改造

var jsApi = 'https://res.wx.qq.com/open/js/jweixin-1.6.0.js';
var amsApiUrl = 'https://apps.game.qq.com/ams/wx/getSignature.php'; // const qqAppid = '';
// const wxAppid = '';

var loginFuncsTips = 'Please use LoginManager,exec from jsBridge is not effect.';
var miloSelfConfig = {
  isMiloWayCookies: true,
  appName: 'wechat'
}; // 加载wxjssdk，活动开发可以自行指定版本号

var loadJsApi = function loadJsApi(jsApiCustom) {
  return new Promise(function (resolve, reject) {
    var loadJsApiUrl = jsApiCustom || jsApi;
    console.log('loadJsApiURL', loadJsApiUrl); // 如果有wx全局变量且有wx.config初始化方法 weiztang

    if (window.wx && window.wx.config) {
      // console.log('window.wx', window.wx);
      resolve(window.wx);
      return;
    }

    loader.loadScript(loadJsApiUrl).then(function (isLoad) {
      if (isLoad && window.wx) {
        // console.log('window.wx', window.wx);
        resolve(window.wx);
      } else {
        reject();
      }
    })["catch"](function (e) {
      reject(e);
    });
  });
}; // 请求微信JSAPI库，并使用签名环境初始化，注意回调需要在微信客户端环境，模拟UA无效


var initConfig = function initConfig(opt, sign, callback) {
  var configWX = function configWX(wx) {
    wx.config({
      debug: opt.debug,
      // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: sign.appId,
      // 必填，公众号的唯一标识
      timestamp: sign.timestamp,
      // 必填，生成签名的时间戳
      nonceStr: sign.nonceStr,
      // 必填，生成签名的随机串
      signature: sign.signature,
      // 必填，签名，见附录1
      jsApiList: opt.jsApiList // 必填，需要使用的JS接口列表，所有JS接口列表见附录2

    });
    wx.ready(function () {
      callback && callback(wx);
    });

    if (opt.debug) {
      wx.error(function (res) {
        alert(res.errMsg);
      });
    }
  };

  var jsApiCustom = null;

  if (opt && opt.jsApiCustom) {
    jsApiCustom = opt.jsApiCustom;
  }

  loadJsApi(jsApiCustom).then(function (wx) {
    configWX(wx);
  })["catch"](function () {});
};
/*
// 使用demo：
import {
    miloJsBridge
} from '@tencent/milo-core'

console.log(miloJsBridge.getJsBridge().getSignature({
    'sAppId': 'wxf8773b4d31a9a719', // 指定的wxappid
    'callback':function(res){
        console.log('callback',res)
    }
}))
 */


var getSignature = function getSignature(opt) {
  // url获取当前页面
  var url = encodeURIComponent(document.location.href); // 构造传递参数

  var params = {
    sUrl: url
  };

  if (opt && opt.sAppId) {
    params.sAppId = opt.sAppId;
  } else if (cookie.get('appid')) {
    // 尝试用登录态里面的appid add by weiztang
    params.sAppId = cookie.get('appid');
  } else {
    // 自动获取ServiceType
    var getServiceType = function getServiceType(serverType) {
      // 首先从URL上获取sServiceType
      var sServiceType = document.location.host.split('.')[0]; // 如果有定义，就从定义上获取ServiceType

      if (opt && opt.iActivityId) {
        var ams_actdesc = window["ams_actdesc_".concat(opt.iActivityId)];

        if (ams_actdesc) {
          sServiceType = ams_actdesc.sServiceType;
        }
      } // 如果用户传值，就从用户的传值获取sServiceType


      if (serverType) {
        sServiceType = serverType;
      }

      return sServiceType;
    };

    var st = null;

    if (opt && opt.sServiceType) {
      st = opt.sServiceType;
    }

    params.sServiceType = getServiceType(st);
  } // 向后端发起查询请求获取微信签名配置config


  miloRequest.ajax({
    url: amsApiUrl,
    type: 'get',
    data: params,
    dataType: 'json',
    success: function success(retdata) {
      if (retdata.iRet == 0) {
        var wxconfig = retdata.jData;

        if (opt && opt.autoConfig) {
          var inintConfigCallback = null;

          if (opt && opt.callback) {
            inintConfigCallback = opt.callback;
          }

          initConfig(opt, wxconfig, inintConfigCallback);
        } else if (opt && opt.callback) {
          opt.callback(wxconfig);
        }
      } else {
        console.log('wxSignErrorMsg:', retdata);
      }
    }
  });
};

var loginByQQAndWX = function loginByQQAndWX() {
  console.log(loginFuncsTips);
};

var loginByWX = function loginByWX() {
  console.log(loginFuncsTips);
};

var loginByQQ = function loginByQQ() {
  console.log(loginFuncsTips);
};

var setAppCookie = function setAppCookie() {
  return new Promise(function (resolve) {
    console.log(loginFuncsTips);
    resolve();
  });
};

var getLoginType = function getLoginType() {
  return new Promise(function (resolve) {
    // 这里是是APP登录态是否特殊处理的开关之一
    resolve(null);
  });
};

var logout = function logout() {
  console.log(loginFuncsTips);
};

var wechat = {
  // 不开放方法，请使用LoginManager
  loginByWX: loginByWX,
  loginByQQ: loginByQQ,
  loginByQQAndWX: loginByQQAndWX,
  setAppCookie: setAppCookie,
  getLoginType: getLoginType,
  logout: logout,
  // jssdk相关方法
  loadJsApi: loadJsApi,
  getSignature: getSignature,
  initConfig: initConfig,
  miloSelfConfig: miloSelfConfig
};
export default wechat;